import { BaseEntity } from '../base-entity';

export class FormCd003Filter extends BaseEntity {
    // tslint:disable-next-line: variable-name
    site_beneficiamento?: string;
    // tslint:disable-next-line: variable-name
    data_hora_apontamento?: Date;
    // tslint:disable-next-line: variable-name
    safra?: string;
    // tslint:disable-next-line: variable-name
    hibrido_rnc?: string;
    // tslint:disable-next-line: variable-name
    lote_cs?: string;
    // tslint:disable-next-line: variable-name
    lote_tb?: string;
    // tslint:disable-next-line: variable-name
    peneira?: string;
    // tslint:disable-next-line: variable-name
    is_incomplete?: boolean;
    usuario?: string;
    numero_campo?: string;
}
